__turbopack_context__.v({
  "Content": "A-1stq_Content",
  "Description": "A-1stq_Description",
  "FeatureItem": "A-1stq_FeatureItem",
  "FeaturesList": "A-1stq_FeaturesList",
  "Icon": "A-1stq_Icon",
  "Root": "A-1stq_Root",
  "Title": "A-1stq_Title",
  "skeleton-loading": "A-1stq_skeleton-loading",
});
